import { useTranslation } from "react-i18next";
import Icon from "../element/icon";
import useMediaUrl from "../hook/use.media.url";

export default function SubmittedMedia({ document, icon = "uil:camera" }) {
  const { t } = useTranslation();
  const url = useMediaUrl(document);
  return (
    <span className="purchase-upload-box purchase-submitted-media">
      <Icon icon={icon} />
      <span className="purchase-upload-copy">
        <span className="_label purchase-upload-name" title={document?.name}>
          {document?.name || t("Not provided")}
        </span>
      </span>
      {url && (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`View ${document.name}`}
        >
          {t("View")} <Icon icon="solar:arrow-right-up-linear" />
        </a>
      )}
    </span>
  );
}
